const o=11;export{o as CPF_LENGTH};
//# sourceMappingURL=constants.js.map
